"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var TimeSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M8.5,1 C12.6421356,1 16,4.35786438 16,8.5 C16,12.6421356 12.6421356,16 8.5,16 C4.35786438,16 1,12.6421356 1,8.5 C1,4.35786438 4.35786438,1 8.5,1 Z M8.5,2 C4.91014913,2 2,4.91014913 2,8.5 C2,12.0898509 4.91014913,15 8.5,15 C12.0898509,15 15,12.0898509 15,8.5 C15,4.91014913 12.0898509,2 8.5,2 Z M9,4 L9,8.293 L11.8535534,11.1464466 C12.0488155,11.3417088 12.0488155,11.6582912 11.8535534,11.8535534 C11.679987,12.0271197 11.4105626,12.0464049 11.2156945,11.9114088 L11.1464466,11.8535534 L8.14644661,8.85355339 L8.10896102,8.81166225 L8.06674743,8.74976515 L8.03761056,8.6905951 L8.01661082,8.62813914 L8.00544807,8.57406693 L8.00182199,8.54281541 L8,4 L9,4 Z" })));
};
TimeSmall.displayName = 'TimeSmall';
exports.default = TimeSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=TimeSmall.js.map